import { createSlice } from "@reduxjs/toolkit";
import { getStatesAction } from "../actions/transactionLogs.action";

const initialState = {
  isError: false,
  isLoading: false,
  data: [],
};

const statesSlice = createSlice({
  name: "Get States",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatesAction.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(getStatesAction.fulfilled, (state, action) => {
      state.data = [...state.data, ...(action?.payload?.body || [])];
      state.isLoading = false;
      if (!action?.payload) state.isError = true;
      else state.isError = false;
    });

    builder.addCase(getStatesAction.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default statesSlice.reducer;
